export default {"src":"/_next/static/media/flo.42a97069.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};